<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
            <DownloadButton />
          </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVCronogramaDeOrdemDeServico()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #stepper>
				<div class="w-full flex justify-center mb-4">
					<RadialStepper
						v-model="etapaAtual"
						:steps="[
							{ name: $t('cronogramForm'), step: 1 },
							{ name: $t('defineOptmizationRule'), step: 2 },
							{ name: $t('planCronogram'), step: 3 },
						]"
					/>
				</div>
			</template>
			<template #form>
				<InputText
					v-model="model.descricao"
					:label="$t('description')"
					@input="onDescriptionChange"
				/>
				<DatePicker
					v-model="model.dataDeInicio"
					:label="$t('startDate')"
					:min-date="dataMinimaParaOCronograma"
				/>
				<DatePicker
					v-model="model.dataDeFinalizacao"
					:label="$t('endDate')"
					:min-date="model.dataDeInicio"
				/>

				<div style="gap: 1.5rem; display: flex; padding: 1rem 0">
					<CardPicker
						v-show="!isEdit"
						:selected="model.cronogramaAutomatico"
						@click="model.cronogramaAutomatico = true"
					>
						<template #header>
							<b><i class="fas fa-magic" /> {{ $t('automatic') }}</b>
						</template>
						<template #description>
							{{ $t('weChoose') }}
						</template>
						<template #button-title>
							{{ model.cronogramaAutomatico ? $t('selected') : $t('select') }}
						</template>
					</CardPicker>

					<CardPicker
						v-show="!isEdit"
						:selected="!model.cronogramaAutomatico"
						@click="model.cronogramaAutomatico = false"
					>
						<template #header>
							<b><i class="fas fa-cogs" /> {{ $t('custom') }}</b>
						</template>
						<template #description>
							{{ $t('youChoose') }}
						</template>
						<template #button-title>
							{{ !model.cronogramaAutomatico ? $t('selected') : $t('select') }}
						</template>
					</CardPicker>
				</div>

				<p
					v-show="isEdit"
					class="container__crud__crudform__visualizar_planejamento"
					@click="visualizarPlanejamentoCadastrado"
				>
					{{ $t('visualizePlan') }} ->
				</p>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
					<Button
						v-if="!isEdit"
						:label="$t('next')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						:loading="salvandoCronograma"
						@click="avancarParaOtimizacoes()"
					/>
					<Button
						v-if="descriptionChanged"
						:label="$t('save')"
						color="trv-default"
						@click="update"
					/>
				</div>
			</template>
		</CrudForm>

		<Modal
			v-show="etapaAtual === 2 || mostrarRegrasDeOtimizacaoNaTelaDePlanejamento"
			style="z-index: 50"
		>
			<RegrasDeOtimizacao
				ref="ref__regrasdeotimizacao"
				:planejamento-ja-gerou-ordens-de-servico="model.cronogramaPlanejado"
				@fecharRegraDeOtimizacao="cancelarRegraDeOtimizacao"
				@confirmarRegraDeOtimizacao="setarRegraDeOtimizacao"
			/>
		</Modal>

		<Modal v-if="etapaAtual === 3">
			<PlanejarCronogramaDeOrdemDeServico
				ref="ref_planejar_cronograma_de_ordem_de_servico"
				:data-de-inicio="model.dataDeInicio"
				:data-de-finalizacao="model.dataDeFinalizacao"
				:planos-de-colheita="plantiosParaPlanoDeColheita"
				:cronograma-id="model.id"
				:filtros-salvos="filtros"
				:regras-de-otimizacao="regrasDeOtimizacao"
				:planejamento-ja-gerou-ordens-de-servico="model.cronogramaPlanejado"
				@clicouEmEditarRegraDeOtimizacao="mostrarRegrasDeOtimizacaoNaTelaDePlanejamento = true"
				@clicouEmVoltar="() => (etapaAtual = 1)"
				@excluiuCronogramaDeOrdemDeServico="excluiuCronogramaDeOrdemDeServico"
			/>
		</Modal>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CardPicker from '../../../components/CardPicker/CardPicker'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DatePicker from '../../../components/DatePicker/DatePicker'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Modal from '../../../components/Modal/Modal'
import Pagination from '../../../components/Pagination/Pagination'
import RadialStepper from '../../../components/RadialStepper/RadialStepper'
import RegrasDeOtimizacao from './RegrasDeOtimizacao/RegrasDeOtimizacao'
import PlanejarCronogramaDeOrdemDeServico from './PlanejarCronogramaDeOrdemDeServico/PlanejarCronogramaDeOrdemDeServico'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	cadastrarCronograma,
	atualizarRegrasDeOtimizacao,
	listarCronogramas,
	atualizarCronogramaDeOS,
} from '../../../services/requests/CronogramaDeOrdemDeServicoRequests'

import download from 'downloadjs'

export default {
	components: {
		Button,
		CardPicker,
		CrudForm,
		CrudTable,
		DatePicker,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Modal,
		Pagination,
		PlanejarCronogramaDeOrdemDeServico,
		RadialStepper,
		RegrasDeOtimizacao,
		KebabMenu,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			descriptionChanged: false,
			headersSelecionados: ['codigo', 'descricao', 'periodo'],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				codigo: '',
				descricao: '',
				dataDeInicio: '',
				dataDeFinalizacao: '',
				cronogramaAutomatico: true,
				cronogramaPlanejado: false,

				periodo: '',
				dataDeInicioAntesDaEdicao: undefined,
				cronogramaAutomaticoParaTabela: true,
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'EX',
				subtitleCardPropertie: 'codigo',
				titleCardPropertie: 'descricao',
			},
			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{ key: 'descricao', value: this.$t('description'), isActive: true },
				{ key: 'periodo', value: this.$t('period'), isActive: true },
				{
					key: 'cronogramaAutomaticoParaTabela',
					value: this.$t('tipoDeCronograma'),
					isActive: false,
				},
			],
			mostrarRegrasDeOtimizacaoNaTelaDePlanejamento: false,
			etapaAtual: 1,
			regrasDeOtimizacao: {
				rendimentoOperacional: [],
				tipoDeOrdemDeServico: [],
				planoDeColheita: [],
				outrasRegras: [
					{
						id: uuidv4(),
						ativo: false,
						tipoDeRegra: 'dias Úteis',
						valor: 0,
						edicaoHabilitada: false,
					},
					{
						id: uuidv4(),
						ativo: false,
						tipoDeRegra: 'dias de Folga',
						valor: 0,
						edicaoHabilitada: false,
					},
				],
			},
			filtros: undefined,
			plantiosParaPlanoDeColheita: undefined,
			salvandoCronograma: false,
		}
	},
	computed: {
		dataMinimaParaOCronograma() {
			if (this.model.dataDeInicioAntesDaEdicao) return this.model.dataDeInicioAntesDaEdicao
			return new Date().toISOString()
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.descricao && this.model.dataDeInicio && this.model.dataDeFinalizacao
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		'model.dataDeInicio'(value) {
			const dataDeFinalizacaoMaiorQueDataDeInicio = value > this.model.dataDeFinalizacao

			if (this.model.dataDeFinalizacao && value && dataDeFinalizacaoMaiorQueDataDeInicio) {
				this.model.dataDeFinalizacao = ''
			}
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['codigo']

		listarCronogramas().then((response) => {
			const { data: cronogramas } = response
			cronogramas.forEach((cronograma) => this.formataCronogramaParaTabela(cronograma))
			this.modelList = cronogramas
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		// Deve ser retirado essa logica abaixo quando o banco for atualizado
		this.modelList = []
		this.tableConfiguration.statusTable = this.$t('noRecordFound')
	},
	methods: {
		/**
		 * Atualiza cronograma de ordem de serviço no banco de dados
		 */
		update() {
			atualizarCronogramaDeOS(this.model).then((response) => {
				this.disableSaveButton = false

				if (response.status === 200) {
					this.showForm = false
					this.descriptionChanged = false
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					window.location.reload()
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui executor no banco de dados
		 */
		deleteModels() {
			//TODO: Implementar a exclusao
			console.log('Implementar exclusão de cronogramas')
		},

		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.descricao !== value
			}
		},

		/**
		 * Formata executor para tabela e crud
		 */
		formataCronogramaParaTabela(cronograma) {
			cronograma.isCheckedToDelete = false

			cronograma.periodo =
				cronograma.dataDeInicio && cronograma.dataDeFinalizacao
					? `${this.formataData(cronograma.dataDeInicio)} a ${this.formataData(cronograma.dataDeFinalizacao)}`
					: ''

			cronograma.cronogramaAutomaticoParaTabela = cronograma.cronogramaAutomatico
				? 'Automático'
				: 'Personalizado'
		},

		formataData(data) {
			const objetoData = new Date(data)
			return `${objetoData.getDate().toString().padStart(2, '0')}/${(objetoData.getMonth() + 1).toString().padStart(2, '0')}/${objetoData.getFullYear()}`
		},

		/**
		 * Método executado quando clica no botão de avancar
		 */
		avancarParaOtimizacoes() {
			if (this.model.cronogramaAutomatico) {
				this.changeFormAndCloseAllActions()
				this.etapaAtual = 2
			} else {
				const body = this.criarObjetoParaCadastrarCronograma()
				this.salvandoCronograma = true
				cadastrarCronograma(body)
					.then((response) => {
						const cronograma = response.data
						this.formataCronogramaParaTabela(cronograma)
						cronograma.regrasDeOtimizacao = this.regrasDeOtimizacao
						this.model = cronograma
						this.modelList.unshift(cronograma)

						this.salvandoCronograma = false
						this.changeFormAndCloseAllActions()
						this.etapaAtual = 3
						this.mostrarRegrasDeOtimizacaoNaTelaDePlanejamento = false
					})
					.catch(() => {
						this.salvandoCronograma = false
					})
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.model.dataDeInicioAntesDaEdicao = this.model.dataDeInicio
			this.setarEConfigurarRegrasDeOtimizacaoParaEdicao()
			this.setarConfiguracoesQueForamUsadosParaSelecionarOsPlantiosDoPlanejamento()

			this.titleForm = this.$t('editarCronogramaOS')
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Seta e configura as regras de otimizacao para conseguir fazer edicao
		 */
		setarEConfigurarRegrasDeOtimizacaoParaEdicao() {
			this.regrasDeOtimizacao = {
				rendimentoOperacional: this.model.regrasDeOtimizacao.rendimentoOperacional,
				tipoDeOrdemDeServico: this.model.regrasDeOtimizacao.tipoDeOrdemDeServico,
				planoDeColheita: this.model.regrasDeOtimizacao.planoDeColheita,
				outrasRegras: this.model.regrasDeOtimizacao.outrasRegras,
			}

			this.$refs.ref__regrasdeotimizacao.regrasDeOtimizacao = this.regrasDeOtimizacao
		},

		setarConfiguracoesQueForamUsadosParaSelecionarOsPlantiosDoPlanejamento() {
			if (this.model.filtros) {
				this.filtros = this.model.filtros

				if (this.filtros.dataDaUltimaMedicao.start && this.filtros.dataDaUltimaMedicao.end) {
					this.filtros.dataDaUltimaMedicao.start = new Date(this.filtros.dataDaUltimaMedicao.start)
					this.filtros.dataDaUltimaMedicao.end = new Date(this.filtros.dataDaUltimaMedicao.end)
				}

				if (this.filtros.dataDePlantio.start && this.filtros.dataDePlantio.end) {
					this.filtros.dataDePlantio.start = new Date(this.filtros.dataDePlantio.start)
					this.filtros.dataDePlantio.end = new Date(this.filtros.dataDePlantio.end)
				}
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.model.cronogramaAutomatico = true
			this.$refs.ref__regrasdeotimizacao.limparRegrasDeOtimizacao()

			this.titleForm = this.$t('cadastrarCronogramaOS')
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.descriptionChanged = false
		},
		setarRegraDeOtimizacao(regrasDeOtimizacao, plantiosParaPlanoDeColheita) {
			this.regrasDeOtimizacao = regrasDeOtimizacao
			this.plantiosParaPlanoDeColheita = plantiosParaPlanoDeColheita

			if (this.etapaAtual === 2) {
				const body = this.criarObjetoParaCadastrarCronograma()
				cadastrarCronograma(body)
					.then((response) => {
						const cronograma = response.data
						this.formataCronogramaParaTabela(cronograma)
						cronograma.regrasDeOtimizacao = this.regrasDeOtimizacao
						this.modelList.unshift(cronograma)
						this.model = cronograma

						this.etapaAtual = 3
						this.$refs.ref__regrasdeotimizacao.habilitarBotoesAposRequisicao()
						this.mostrarRegrasDeOtimizacaoNaTelaDePlanejamento = false
					})
					.catch(() => {
						this.$refs.ref__regrasdeotimizacao.habilitarBotoesAposRequisicao()
					})
			} else if (this.etapaAtual === 3) {
				atualizarRegrasDeOtimizacao(this.model.id, this.regrasDeOtimizacao)
					.then(() => {
						this.$refs.ref__regrasdeotimizacao.habilitarBotoesAposRequisicao()
						this.$refs.ref_planejar_cronograma_de_ordem_de_servico.otimizarOrdemDeServico()
						this.mostrarRegrasDeOtimizacaoNaTelaDePlanejamento = false
					})
					.catch(() => {
						this.$refs.ref__regrasdeotimizacao.habilitarBotoesAposRequisicao()
					})
			}
		},
		criarObjetoParaCadastrarCronograma() {
			return {
				id: uuidv4(),
				descricao: this.model.descricao,
				inicioDoCronograma: new Date(this.model.dataDeInicio),
				prazoDoCronograma: new Date(this.model.dataDeFinalizacao),
				cronogramaAutomatico: this.model.cronogramaAutomatico,
				regraDeOtimizacao: {
					regrasDeRendimentoOperacional: this.regrasDeOtimizacao.rendimentoOperacional.map(
						(regra) => {
							return {
								id: regra.id,
								executorId: regra.coletor,
								parcelasPorDia: regra.parcelasPorDia,
								prioridade: regra.prioridade,
							}
						},
					),
					regrasPorTipoDeOrdemDeServico: this.regrasDeOtimizacao.tipoDeOrdemDeServico.map(
						(regra) => {
							return {
								id: regra.id,
								tipoDePrazo: regra.tipoDePrazo,
								opcaoDeCriterio: regra.dataReferencia,
								prioridade: regra.prioridade,
								quantidadeDeMeses: regra.quantidadeDeMeses,
								tipoDeOrdemDeServico: regra.tipoDeServico,
							}
						},
					),
					regrasDePlanoDeColheita: this.regrasDeOtimizacao.planoDeColheita.map((regra) => {
						return {
							id: regra.id,
							prioridade: regra.prioridade,
							quantidadeDeMeses: regra.quantidadeDeMeses,
							tipoDePrazo: regra.tipoDePrazo,
						}
					}),
					regrasDeDatas: this.regrasDeOtimizacao.outrasRegras.map((regra) => {
						return {
							id: regra.id,
							diaUtil: regra.tipoDeRegra === 'dias Úteis',
							quantidadeDeDias: regra.valor,
						}
					}),
				},
			}
		},
		cancelarRegraDeOtimizacao() {
			if ((this.regrasDeOtimizacao && this.etapaAtual !== 3) || this.etapaAtual === 2)
				this.etapaAtual = 1
			else this.mostrarRegrasDeOtimizacaoNaTelaDePlanejamento = false
		},
		visualizarPlanejamentoCadastrado() {
			this.etapaAtual = 3
			this.showForm = false
		},
		excluiuCronogramaDeOrdemDeServico(cronogramaId) {
			const indiceDoCronogramaParaExcluir = this.modelList
				.map((cronograma) => cronograma.id)
				.indexOf(cronogramaId)
			this.modelList.splice(indiceDoCronogramaParaExcluir, 1)
		},
		downloadCSVCronogramaDeOrdemDeServico() {
			let cabecalhoDoCsvCronogramaOrdemDeServico = [
				'Código',
				'Descrição',
				'Período',
				'Tipo de Cronograma',
			]
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvCronogramaOrdemDeServico,
				...items.map((item) => [
					item.codigo,
					item.descricao,
					item.periodo,
					item.cronogramaAutomaticoParaTabela,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_cronogramas_ordem_de_servico.csv', 'text/csv')
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>

<style scoped>
.container__crud__crudform__visualizar_planejamento {
	cursor: pointer;
	text-align: end;
	margin: 0;
}

.container__crud__crudform__visualizar_planejamento:hover {
	text-decoration: underline;
}
</style>
